import { GetByidObrasGestaoDeResiduosResponse } from "../../../data/daos/read/get_all_obras_gestao_de_residuos";
import { IGetByIdGestaoDeResiduosUseCase } from "../../../presentation/useCases/read/get_by_id_gestao_de_residuos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetByIdGestaoDeResiduosUseCase
 */

export class GetByIdGestaoDeResiduosUseCase implements IGetByIdGestaoDeResiduosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getByIdGestaoDeResiduos(id: number): Promise<GetByidObrasGestaoDeResiduosResponse> {
    const response = await this.repository.getByIdGestaoResiduos({ id });
    return response;
  }
}
